// --------------------------
// 在password input 自動加上顯示按鈕
//
// 改寫 clearInput
//
// author: gray
// createtime: 2016/01/30
// --------------------------

window.InifECApp.directive('showHideInput', ['$parse', function($parse) {

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attr) {

            var init = function() {
                setShowHideBtn();
            }

            var setShowHideBtn = function() {

                var htmlMarkup = '<span class="show-hide-btn">'
                               + '<span class="password-show">顯示</span>'
                               + '<span class="password-hide">隱藏</span>'
                               + '</span>';
                var btn = angular.element(htmlMarkup);
                element.after(btn);

                btn.on('click', function(event) {
                    if (element.attr('type') == 'password') {
                        element.attr('type', 'text');
                        btn.removeClass('show-btn').addClass('hide-btn');
                        element.focus();
                    } else {
                        element.attr('type', 'password');
                        btn.removeClass('hide-btn').addClass('show-btn');
                        element.focus();
                    }
                });

                scope.$watch(attr.ngModel, function(val) {
                    var hasValue = val && val.length > 0;
                    
                    btn.css('visibility', hasValue ? 'visible' : 'hidden');

                    if (hasValue && element.attr('type') == 'password') {
                        btn.removeClass('hide-btn').addClass('show-btn');
                    } else if (hasValue && element.attr('type') == 'text') {
                        btn.removeClass('show-btn').addClass('hide-btn');
                    }
                });
            }

            init();
        }
    };
}]);
